/**
 * CONTROLS tab for settings panel.
 * Read-only display of current keybindings.
 */

import styles from './DesignTab.module.css';

const BINDINGS = [
  { action: 'Thrust Forward', key: 'W' },
  { action: 'Brake / Reverse', key: 'S' },
  { action: 'Strafe Left', key: 'A' },
  { action: 'Strafe Right', key: 'D' },
  { action: 'Aim', key: 'Mouse' },
  { action: 'Afterburner', key: 'Shift' },
  { action: 'Brake', key: 'Ctrl' },
  { action: 'Debug Panel', key: '`' },
  { action: 'Settings', key: 'Escape' },
] as const;

export function ControlsTab() {
  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionTitle}>Keybindings</span>
        </div>
        <div className={styles.sectionBody}>
          {BINDINGS.map((b) => (
            <div key={b.action} className={styles.sliderRow}>
              <span className={styles.sliderLabel}>{b.action}</span>
              <span className={styles.sliderValue} style={{ minWidth: 60 }}>{b.key}</span>
            </div>
          ))}
          <p style={{ color: 'rgba(255,255,255,0.3)', fontSize: 10, margin: '8px 0 0 0' }}>
            Custom keybindings coming in a future update.
          </p>
        </div>
      </div>
    </div>
  );
}
